import { Button, DatePicker, Input, Radio, Space, Typography } from "antd";
import React, { useState } from "react";
import moment from "moment";

import { NOTICE_CATEGORIES } from "../../constants";

const { Search } = Input;
const { Text } = Typography;

const NoticesToolbar = ({
  filters,
  onFiltersChange,
  onAddNotice,
  showFilters,
}) => {
  const [searchKeyword, setSearchKeyword] = useState(
    filters.searchKeyword || ""
  );

  return (
    <>
      <Space
        style={{
          width: "100%",
          marginBottom: "1.25rem",
          justifyContent: showFilters ? "space-between" : "flex-end",
        }}
        direction="horizontal"
        align="end"
        wrap
      >
        {showFilters && (
          <Space wrap>
            <Radio.Group
              value={filters.category}
              buttonStyle="solid"
              onChange={(event) => {
                onFiltersChange("category", event.target.value);
              }}
            >
              <Radio.Button value="all">All</Radio.Button>
              <Radio.Button value={NOTICE_CATEGORIES.PRESS_RELEASE}>
                Press releases
              </Radio.Button>
              <Radio.Button value={NOTICE_CATEGORIES.PROCUREMENT}>
                Procurement
              </Radio.Button>
              <Radio.Button value={NOTICE_CATEGORIES.HR}>HR</Radio.Button>
              <Radio.Button value={NOTICE_CATEGORIES.OTHERS}>
                Others
              </Radio.Button>
              <Radio.Button value="archived">Archived</Radio.Button>
            </Radio.Group>
          </Space>
        )}
        <Space align="end" wrap>
          {showFilters && (
            <>
              <Space direction="vertical">
                <Text>Start Date</Text>
                <DatePicker
                  format="MM/DD/YYYY"
                  value={filters.startDate}
                  placeholder="Select start date"
                  onChange={(value) => {
                    onFiltersChange("startDate", value);
                  }}
                  disabledDate={(current) => {
                    return moment().add(0, "days") < current;
                  }}
                />
              </Space>
              <Space direction="vertical">
                <Text>End Date</Text>
                <DatePicker
                  format="MM/DD/YYYY"
                  value={filters.endDate}
                  placeholder="Select end date"
                  onChange={(value) => {
                    onFiltersChange("endDate", value);
                  }}
                  disabledDate={(current) => {
                    return (
                      moment().add(0, "days") < current ||
                      filters.startDate > current
                    );
                  }}
                />
              </Space>
              <Space direction="vertical">
                <Text>Search Title</Text>
                <Search
                  allowClear
                  placeholder="Search"
                  value={searchKeyword}
                  onChange={(event) => setSearchKeyword(event.target.value)}
                  onSearch={(value) => {
                    onFiltersChange("searchKeyword", value);
                  }}
                  enterButton
                  style={{ width: "350px" }}
                />
              </Space>
            </>
          )}

          <Button type="primary" onClick={onAddNotice}>
            Add Notice
          </Button>
        </Space>
      </Space>
    </>
  );
};

export default NoticesToolbar;
